import React from 'react'
    import { CheckCircle, Target, Eye, Heart } from 'lucide-react'

    const About = () => {
      const values = [
        {
          icon: <Target className="h-8 w-8 text-blue-500" />,
          title: 'Mission',
          description: 'To empower businesses with innovative technology solutions that drive growth and success.'
        },
        {
          icon: <Eye className="h-8 w-8 text-green-500" />,
          title: 'Vision',
          description: 'To be the leading provider of cutting-edge web applications that transform industries.'
        },
        {
          icon: <Heart className="h-8 w-8 text-red-500" />,
          title: 'Values',
          description: 'Innovation, integrity, excellence, and customer-centricity guide everything we do.'
        }
      ]

      const achievements = [
        '500+ Projects Completed',
        '99.9% Uptime Guarantee',
        '24/7 Customer Support',
        'Award-Winning Design'
      ]

      return (
        <div className="min-h-screen bg-gray-50" data-component-path="client/src/pages/About.jsx" data-component-line="1:4" data-component-id="client/src/pages/About.jsx:1:4">
          {/* Hero Section */}
          <section 
            className="relative py-20 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80)'
            }}
            data-component-path="client/src/pages/About.jsx" data-component-line="2:6" data-component-id="client/src/pages/About.jsx:2:6"
          >
            <div className="absolute inset-0 bg-black bg-opacity-60" data-component-path="client/src/pages/About.jsx" data-component-line="3:8" data-component-id="client/src/pages/About.jsx:3:8"></div>
            <div className="relative z-10 max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="4:8" data-component-id="client/src/pages/About.jsx:4:8">
              <h1 className="text-5xl md:text-6xl font-bold text-white mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="5:10" data-component-id="client/src/pages/About.jsx:5:10">About Us</h1>
              <p className="text-xl text-gray-200" data-component-path="client/src/pages/About.jsx" data-component-line="6:10" data-component-id="client/src/pages/About.jsx:6:10">
                Discover our story, mission, and the passionate team behind our success
              </p>
            </div>
          </section>

          {/* Story Section */}
          <section className="py-20 bg-white" data-component-path="client/src/pages/About.jsx" data-component-line="7:6" data-component-id="client/src/pages/About.jsx:7:6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="8:8" data-component-id="client/src/pages/About.jsx:8:8">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-component-path="client/src/pages/About.jsx" data-component-line="9:10" data-component-id="client/src/pages/About.jsx:9:10">
                <div data-component-path="client/src/pages/About.jsx" data-component-line="10:12" data-component-id="client/src/pages/About.jsx:10:12">
                  <h2 className="text-4xl font-bold text-gray-900 mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="11:14" data-component-id="client/src/pages/About.jsx:11:14">Our Story</h2>
                  <p className="text-lg text-gray-600 mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="12:14" data-component-id="client/src/pages/About.jsx:12:14">
                    Founded with a vision to revolutionize the digital landscape, we've been at the forefront of 
                    technological innovation for over a decade. Our journey began with a simple belief: that 
                    exceptional software should be accessible to everyone.
                  </p>
                  <p className="text-lg text-gray-600 mb-8" data-component-path="client/src/pages/About.jsx" data-component-line="13:14" data-component-id="client/src/pages/About.jsx:13:14">
                    Today, we're proud to serve clients worldwide, delivering solutions that not only meet their 
                    needs but exceed their expectations. Our commitment to excellence drives us to continuously 
                    push boundaries and explore new possibilities.
                  </p>
                  <div className="grid grid-cols-2 gap-4" data-component-path="client/src/pages/About.jsx" data-component-line="14:14" data-component-id="client/src/pages/About.jsx:14:14">
                    {achievements.map((achievement, index) => (
                      <div key={index} className="flex items-center space-x-2" data-component-path="client/src/pages/About.jsx" data-component-line="15:16" data-component-id="client/src/pages/About.jsx:15:16">
                        <CheckCircle className="h-5 w-5 text-green-500" data-component-path="client/src/pages/About.jsx" data-component-line="16:18" data-component-id="client/src/pages/About.jsx:16:18" />
                        <span className="text-gray-700 font-medium" data-component-path="client/src/pages/About.jsx" data-component-line="17:18" data-component-id="client/src/pages/About.jsx:17:18">{achievement}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="relative" data-component-path="client/src/pages/About.jsx" data-component-line="18:12" data-component-id="client/src/pages/About.jsx:18:12">
                  <img 
                    src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                    alt="Team collaboration"
                    className="rounded-lg shadow-2xl"
                    loading="lazy"
                    data-component-path="client/src/pages/About.jsx" data-component-line="19:14" data-component-id="client/src/pages/About.jsx:19:14"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Values Section */}
          <section className="py-20 bg-gray-50" data-component-path="client/src/pages/About.jsx" data-component-line="20:6" data-component-id="client/src/pages/About.jsx:20:6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="21:8" data-component-id="client/src/pages/About.jsx:21:8">
              <div className="text-center mb-16" data-component-path="client/src/pages/About.jsx" data-component-line="22:10" data-component-id="client/src/pages/About.jsx:22:10">
                <h2 className="text-4xl font-bold text-gray-900 mb-4" data-component-path="client/src/pages/About.jsx" data-component-line="23:12" data-component-id="client/src/pages/About.jsx:23:12">Our Core Values</h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-component-path="client/src/pages/About.jsx" data-component-line="24:12" data-component-id="client/src/pages/About.jsx:24:12">
                  These principles guide our decisions and shape our culture
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-component-path="client/src/pages/About.jsx" data-component-line="25:10" data-component-id="client/src/pages/About.jsx:25:10">
                {values.map((value, index) => (
                  <div 
                    key={index}
                    className="text-center p-8 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-200"
                    data-component-path="client/src/pages/About.jsx" data-component-line="26:12" data-component-id="client/src/pages/About.jsx:26:12"
                  >
                    <div className="flex justify-center mb-4" data-component-path="client/src/pages/About.jsx" data-component-line="27:14" data-component-id="client/src/pages/About.jsx:27:14">
                      {value.icon}
                    </div>
                    <h3 className="text-2xl font-semibold text-gray-900 mb-4" data-component-path="client/src/pages/About.jsx" data-component-line="28:14" data-component-id="client/src/pages/About.jsx:28:14">{value.title}</h3>
                    <p className="text-gray-600" data-component-path="client/src/pages/About.jsx" data-component-line="29:14" data-component-id="client/src/pages/About.jsx:29:14">{value.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      )
    }

    export default About